import { trackEvent } from '../../../modules/analytics';

const events = {
  clickFeatureItemReadMore: feature => {
    trackEvent(
      null,
      {
        eventCategory: 'Homepage',
        eventAction: 'Click',
        eventLabel: `Features ${feature} Read More Link`,
      },
      { providers: [ga] }
    );
  },
  clickHeroSignUpCta: () => {
    trackEvent(
      null,
      {
        eventCategory: 'Homepage',
        eventAction: 'Click',
        eventLabel: 'Hero Sign Up CTA',
      },
      { providers: [ga] }
    );
  },
  clickVideoSignUpLink: () => {
    trackEvent(
      null,
      {
        eventCategory: 'Homepage',
        eventAction: 'Click',
        eventLabel: 'Video Sign Up Link',
      },
      { providers: [ga] }
    );
  },
  clickVideoAppLink: () => {
    trackEvent(
      null,
      {
        eventCategory: 'Homepage',
        eventAction: 'Click',
        eventLabel: 'Video App Link',
      },
      { providers: [ga] }
    );
  },
  clickVideoLearnMoreLink: () => {
    trackEvent(
      null,
      {
        eventCategory: 'Homepage',
        eventAction: 'Click',
        eventLabel: 'Video Learn More Link',
      },
      { providers: [ga] }
    );
  },
  clickGetStartedCta: () => {
    trackEvent(
      null,
      {
        eventCategory: 'Homepage',
        eventAction: 'Click',
        eventLabel: 'Get Started CTA',
      },
      { providers: [ga] }
    );
  },
  clickSwitchToAnchorLink: () => {
    trackEvent(
      null,
      {
        eventCategory: 'Homepage',
        eventAction: 'Click',
        eventLabel: 'Switch To Anchor Link',
      },
      { providers: [ga] }
    );
  },
};

export { events };
